import { c as _c } from "react/compiler-runtime";
import { FUNNELS_API } from 'modules/funnels/api/funnels-api';
import BaseConfiguration from 'modules/funnels/funnel/components/step-configuration-tab/base-configuration-tab/components/base-configuration';
import StepConfigurationTabLayout from 'modules/funnels/funnel/components/step-configuration-tab/step-configuration-tab-layout';
import { useBaseFunnelStepConfigurationSettings } from 'modules/funnels/funnel/hooks/use-base-funnel-step-configuration-settings';
import { useFunnel } from 'modules/funnels/funnel/hooks/use-funnel';
import { useFunnelStepsList } from 'modules/funnels/funnel/hooks/use-funnel-steps-list';
import { useResetFunnelStepPageTemplate } from 'modules/funnels/funnel/hooks/use-reset-funnel-step-page-template';
import { useUpdateBaseConfigurationTab } from 'modules/funnels/funnel/hooks/use-update-base-configuration-tab';
import { BaseFunnelStepConfigurationEditInterface, BaseFunnelStepConfigurationInterface } from 'modules/funnels/funnel/types/base-funnel-step-configuration-settings-interface';
import { FunnelStepInterface } from 'modules/funnels/funnel/types/funnel-step-interface';
import { getFunnelStepPreviewUrl, getStepPreviewUrl } from 'modules/funnels/funnel/utils/page-utils';
import { FunnelId } from 'modules/funnels/types/funnel-interface';
import React from 'react';
import { Loader } from 'shared/components/loader';
import { getPageEditorUrl } from 'shared/utils/get-page-editor-url';
interface BaseConfigurationTabProps {
  funnelStep: FunnelStepInterface;
  funnelId: FunnelId;
  showPreview?: boolean;
}
function BaseConfigurationTab(t0) {
  const $ = _c(31);
  const {
    funnelStep,
    funnelId,
    showPreview
  } = t0;
  const {
    funnelStepConfigurationSettings,
    mutateFunnelStepConfigurationSettings
  } = useBaseFunnelStepConfigurationSettings(funnelStep.id);
  const {
    funnel
  } = useFunnel(funnelId);
  const {
    mutateFunnelStepsList
  } = useFunnelStepsList(funnelId);
  let t1;
  if ($[0] !== funnelId || $[1] !== funnelStep.id) {
    t1 = {
      funnelId,
      funnelStepId: funnelStep.id
    };
    $[0] = funnelId;
    $[1] = funnelStep.id;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  const {
    resetFunction
  } = useResetFunnelStepPageTemplate(t1);
  const t2 = `${FUNNELS_API}/steps/${funnelStep.id}`;
  let t3;
  if ($[3] !== funnelId || $[4] !== funnelStep.id || $[5] !== t2) {
    t3 = {
      funnelStepId: funnelStep.id,
      funnelId,
      updateUrl: t2
    };
    $[3] = funnelId;
    $[4] = funnelStep.id;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const {
    updateFetcher
  } = useUpdateBaseConfigurationTab(t3);
  let t4;
  if ($[7] !== funnelStep.id || $[8] !== mutateFunnelStepConfigurationSettings || $[9] !== mutateFunnelStepsList || $[10] !== updateFetcher) {
    t4 = async baseData => {
      ;
      try {
        await updateFetcher(baseData, async () => {
          await mutateFunnelStepConfigurationSettings(data => {
            if (data) {
              return {
                ...data,
                name: baseData.name,
                page: {
                  ...data.page,
                  path: baseData.page.path
                }
              };
            }
          }, false);
          await mutateFunnelStepsList(data_0 => {
            if (data_0) {
              return data_0.map(dataFunnelStep => {
                if (dataFunnelStep.id === funnelStep.id) {
                  return {
                    ...dataFunnelStep,
                    name: baseData.name
                  };
                }
                return dataFunnelStep;
              });
            }
          }, false);
        });
      } catch (t5) {
        const e = t5;
        throw e;
      }
    };
    $[7] = funnelStep.id;
    $[8] = mutateFunnelStepConfigurationSettings;
    $[9] = mutateFunnelStepsList;
    $[10] = updateFetcher;
    $[11] = t4;
  } else {
    t4 = $[11];
  }
  const handleSave = t4;
  if (!funnelStepConfigurationSettings || !funnel || !funnelStep.page) {
    let t5;
    if ($[12] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="flex h-full items-center justify-center py-12"><Loader className="scale-150" /></div>;
      $[12] = t5;
    } else {
      t5 = $[12];
    }
    return t5;
  }
  let t5;
  if ($[13] !== funnel.domain.domainName || $[14] !== funnelStep.inRunningSplitTest || $[15] !== funnelStepConfigurationSettings.page.path || $[16] !== showPreview) {
    t5 = showPreview ? getFunnelStepPreviewUrl(funnel.domain.domainName, funnelStepConfigurationSettings.page.path) : getStepPreviewUrl(funnel.domain.domainName, funnelStepConfigurationSettings.page.path, funnelStep.inRunningSplitTest);
    $[13] = funnel.domain.domainName;
    $[14] = funnelStep.inRunningSplitTest;
    $[15] = funnelStepConfigurationSettings.page.path;
    $[16] = showPreview;
    $[17] = t5;
  } else {
    t5 = $[17];
  }
  const viewLinkUrl = t5;
  let t6;
  if ($[18] !== funnelStep.page.id) {
    t6 = getPageEditorUrl(funnelStep.page.id);
    $[18] = funnelStep.page.id;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  const t7 = funnel?.domain.domainName;
  let t8;
  if ($[20] !== funnelStep.inRunningSplitTest || $[21] !== funnelStepConfigurationSettings.name || $[22] !== funnelStepConfigurationSettings.page.path || $[23] !== handleSave || $[24] !== t7) {
    t8 = <BaseConfiguration onSave={handleSave} domainName={t7} name={funnelStepConfigurationSettings.name} path={funnelStepConfigurationSettings.page.path} pathDisabled={funnelStep.inRunningSplitTest} />;
    $[20] = funnelStep.inRunningSplitTest;
    $[21] = funnelStepConfigurationSettings.name;
    $[22] = funnelStepConfigurationSettings.page.path;
    $[23] = handleSave;
    $[24] = t7;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] !== resetFunction || $[27] !== t6 || $[28] !== t8 || $[29] !== viewLinkUrl) {
    t9 = <><StepConfigurationTabLayout viewLinkUrl={viewLinkUrl} editLinkUrl={t6} onChangeTemplate={resetFunction}>{t8}</StepConfigurationTabLayout></>;
    $[26] = resetFunction;
    $[27] = t6;
    $[28] = t8;
    $[29] = viewLinkUrl;
    $[30] = t9;
  } else {
    t9 = $[30];
  }
  return t9;
}
export default BaseConfigurationTab;